import {AssignmentTypesOrder} from "Constants/constants";

export default function orderAssignmentsByAssignmentType(assignments){
  if(!assignments || !assignments.length) return [];

  return assignments.sort((a,b) =>
    AssignmentTypesOrder.indexOf(a.assignmentType) - AssignmentTypesOrder.indexOf(b.assignmentType));
}